<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 水质在线监测 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">水质在线监测</span>
    </div>
    <div class="headerUnit">
      <span style="flex-grow: 2">位置</span>
      <span style="flex-grow: 1">时间</span>
      <span style="flex-grow: 1">浊度NTU</span>
      <span style="flex-grow: 1">温度℃</span>
      <span style="flex-grow: 2">PH</span>
    </div>
    <div class="dataWrap">
      <div class="rawWrap">
        <div class="rawWater">
          <img src="~@/assets/myImg/1/icon-water.png" />
          <span>原水</span>
        </div>
        <div class="tableItem" style="background: rgba(103, 169, 255, 0.15)" v-for="item in rawWaterList"
          :key="item.id">
          <div style="flex-grow: 2" class="tableItemDiv">
            <a-tooltip>
              <template slot="title">{{ item.address }}</template>
              {{ item.address }}
            </a-tooltip>
          </div>
          <span style="flex-grow: 1">{{ item.time }}</span>
          <span style="flex-grow: 1">{{ item.turbidity }}</span>
          <span style="flex-grow: 1">{{ item.chlorine }}</span>
          <span style="flex-grow: 1">{{ item.ph }}</span>
        </div>
        <div class="rawWater">
          <img src="~@/assets/myImg/1/icon-water.png" />
          <!-- <span>出厂水</span> -->
          <!-- <span>原水处理</span> -->
          <span>水厂处理</span>
        </div>
        <div class="tableItem" style="background: rgba(0, 235, 238, 0.15)" v-for="item in FactoryWaterList"
          :key="item.id">
          <div style="flex-grow: 2" class="tableItemDiv">
            <a-tooltip>
              <template slot="title">{{ item.address }}</template>
              {{ item.address }}
            </a-tooltip>
          </div>
          <span style="flex-grow: 1">{{ item.time }}</span>
          <span style="flex-grow: 1">{{ item.turbidity }}</span>
          <span style="flex-grow: 1">{{ item.chlorine }}</span>
          <span style="flex-grow: 1">{{ item.ph }}</span>
        </div>
      </div>
    </div>
    <div class="headerUnit">
      <span style="flex-grow: 2">位置</span>
      <span style="flex-grow: 1">时间</span>
      <span style="flex-grow: 1">浊度NTU</span>
      <span style="flex-grow: 1">余氯mg/L</span>
      <span style="flex-grow: 2">PH</span>
    </div>
    <div class="dataWrap">
      <div class="rawWrap">
        <div class="rawWater">
          <img src="~@/assets/myImg/1/icon-water.png" />
          <span>管网末梢水</span>
        </div>
        <div class="tableItem" style="background: rgba(0, 42, 245, 0.15)" v-for="item in TipWaterList" :key="item.id">
          <div style="flex-grow: 2" class="tableItemDiv">
            <a-tooltip>
              <template slot="title">{{ item.address }}</template>
              {{ item.address }}
            </a-tooltip>
          </div>
          <span style="flex-grow: 1">{{ item.time }}</span>
          <span style="flex-grow: 1">{{ item.turbidity }}</span>
          <span style="flex-grow: 1">{{ item.chlorine }}</span>
          <span style="flex-grow: 1">{{ item.ph }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'WaterMonitoring',
  components: {},
  data () {
    return {
      rawWaterList: [
        {
          // name: '龙虎洞',
          // time: '15:00',
          // NTU: 6.23,
          // chlorine: '',
          // PH: '',
          // id: 1
        }
      ],
      FactoryWaterList: [
        {
          // name: '老城区',
          // time: '15:00',
          // NTU: 0.22,
          // chlorine: 0.38,
          // PH: 7.1,
          // id: 2
        },
        {
          // name: '新城区',
          // time: '15:00',
          // NTU: 0.24,
          // chlorine: 0.4,
          // PH: 7.1,
          // id: 3
        }
      ],
      TipWaterList: [
        {
          // name: '二中',
          // time: '15:00',
          // NTU: 0.32,
          // chlorine: 0.12,
          // PH: 7.1,
          // id: 4
        },
        {
          // name: '职中',
          // time: '15:00',
          // NTU: 0.28,
          // chlorine: 0.09,
          // PH: 7.1,
          // id: 5
        },
        {
          // name: '予乐',
          // time: '15:00',
          // NTU: 0.36,
          // chlorine: 0.07,
          // PH: 7.0,
          // id: 5
        }
      ]
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  created () {
    this.getList()
    this.timer = setInterval(() => {
      this.getList()
      // 你获取echarts数据的方法
    }, 1000 * 10)
  },
  methods: {
    getList () {
      this.$http.get('/pipe-network/water_quality/screen-quality').then((res) => {
        // this.rawWaterList=res.data[0].result
        // this.FactoryWaterList=res.data[1].result
        // this.TipWaterList=res.data[2].result
        this.rawWaterList = res.data[0].result
        this.FactoryWaterList = res.data[1].result
        this.TipWaterList = res.data[2].result
      })
    }
  },
  filters: {
    zeroFormat (msg) {
      if (msg < 10) {
        return '0' + msg
      } else {
        return msg
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 396px;
  width: 376px;
  background: url(~@/assets/myImg/box-07.png) no-repeat;
  background-size: cover;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .headerUnit {
    padding: 0 10px;
    width: 100%;
    height: 30px;
    background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    span {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 15px;
      color: #15a9f1;
      font-weight: 600;
    }
  }

  .dataWrap {
    // height: 318px;
    width: 100%;
    padding: 0 10px;
    padding-bottom: 10px;
    // padding-top:20px;
    overflow-x: hidden;
    overflow-y: auto;

    // .rawWrap{
    //      height: 356px;
    // width: 100%;
    // padding: 0 10px;
    // padding-bottom: 10px;
    // // padding-top:20px;
    // overflow-x: hidden;
    // overflow-y: auto;
    // }
    .rawWater {
      width: 100%;
      height: 30px;
      padding: 0 6px;
      display: flex;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
      }

      span {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 16px;
        color: #00ebee;
        font-weight: 600;
        margin-left: 8px;
      }
    }

    .tableItem {
      width: 100%;
      min-height: 30px;

      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      text-align: center;

      .tableItemDiv {
        min-width: 40px;
        max-width: 60px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;

        span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      span {
        display: inline-block;
        min-width: 40px;
        max-width: 60px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        color: #ffffff;
        font-weight: 600;
        overflow: hidden;
      }
    }
  }

  /*全局滚动条样式*/
  .dataWrap::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .dataWrap::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.35);
    border-radius: 5px;
  }

  .dataWrap::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
}
</style>
